import { useCallback, useState } from 'react';

import { RECENT_SEARCH_KEYWORD } from '../constants';

const MAX_RECENT_SEARCH_KEYWORD = 5;

export const useRecentSearchKeyword = () => {
  const getStoredKeywords = useCallback(() => {
    const storedKeywords = localStorage.getItem(RECENT_SEARCH_KEYWORD);
    return storedKeywords ? JSON.parse(storedKeywords) : [];
  }, []);

  const [recentSearchKeywords, setRecentSearchKeywords] = useState<string[]>(getStoredKeywords());

  const addRecentSearchKeyword = useCallback((keyword: string) => {
    if (!keyword.trim()) return;

    setRecentSearchKeywords(prev => {
      const updatedKeywords = [keyword, ...prev.filter(item => item !== keyword)];
      const newKeywords = updatedKeywords.slice(0, MAX_RECENT_SEARCH_KEYWORD);

      localStorage.setItem(RECENT_SEARCH_KEYWORD, JSON.stringify(newKeywords));
      return newKeywords;
    });
  }, []);

  return { recentSearchKeywords, addRecentSearchKeyword };
};
